import { render, staticRenderFns } from "./RubricaComponente.vue?vue&type=template&id=15ebf38a&"
import script from "./RubricaComponente.vue?vue&type=script&lang=js&"
export * from "./RubricaComponente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports